import { render, staticRenderFns } from "./gj-charger-select.vue?vue&type=template&id=2b506073&scoped=true&"
import script from "./gj-charger-select.vue?vue&type=script&lang=js&"
export * from "./gj-charger-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b506073",
  null
  
)

export default component.exports